import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';

import { getSupplierJobAction } from '../../../../modules/supplierJobs/Actions';

import {
  getPendingSupplierJobsAction,
  deleteSinglePendingSupplierProdcutAction,
  getSinglePendingSupplierJobAction,
  moderateCreateSinglePendingSupplierJobAction,
  updatePendingSupplierJobAction
} from '../../../../modules/supplierModeration/supplierJobs/Actions';
import {
  supplierJobsIsLoadingSelector,
  supplierJobByIdSelector
} from '../../../../modules/supplierJobs/Selectors';

import {
  InputField,
  CheckBox,
  TextArea,
  MultiInputField,
  SearchableSelect,
  MultiUpload,
  FormSectionTitle,
  Separator
} from '../../../../components/form';

import ModerationForm from '../../../../components/form/ModerationForm';
import { pendingSupplierJobByIdSelector } from '../../../../modules/supplierModeration/supplierJobs/Selectors';
import Checkbox from '../../../../components/form/Checkbox';
import { getSupplierCategoriesAction } from '../../../../modules/supplierCategories/Actions';
import getLangData from '../../../../utils/getLangData';
import {
  supplierCategoriesIsLoadingSelector,
  supplierCategoriesListSelector
} from '../../../../modules/supplierCategories/Selectors';
import { suppliersIsLoadingSelector } from '../../../../modules/suppliers/Selectors';

const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;

const SupplierJobsForm = props => {
  const {
    jobId,
    moderationId,
    isLoading,
    updateSupplierJob,
    getSupplierJob,
    supplierJob,
    deleteSupplier,
    moderateSupplierJob,
    getJobs,
    getCategories,
    categories,
    suppliersIsLoading,
    categoriesIsLoading
  } = props;

  useEffect(() => {
    // getSupplierJob(jobId);
    getJobs();
  }, [getSupplierJob, jobId]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...supplierJob
      }}
      onSubmit={values => {
        moderateSupplierJob(
          {
            id: jobId
          },
          values.moderationType
        );
      }}
    >
      {({ values, handleSubmit }) => (
        <ModerationForm
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          heading={
            supplierJob ? `Update [${supplierJob.name}]` : 'Create Supplier Job'
          }
        >
          <FormSectionTitle>Basic Information</FormSectionTitle>

          <SearchableSelect
            name={'supplierCID'}
            label={getLangData().general_words.supplier_categories}
            getItems={getCategories}
            options={categories}
            isLoading={categoriesIsLoading}
          />
          <InputField label={fieldsLang?.title} name='jobTitle' />
          <TextArea name='jobDescription' label={fieldsLang.descrition} />
          <InputField
            label={fieldsLang?.yearsOfExperience}
            name='yearsOfExperience'
            type='number'
          />
          <Checkbox
            name='trainingAvailable'
            label={fieldsLang.trainingAvailable}
          />
          <MultiInputField name='skillsRequired' label={fieldsLang.skills} />
        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const jobId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    jobId,
    isLoading: supplierJobsIsLoadingSelector(state),
    // supplierJob: supplierJobByIdSelector(state, jobId),
    supplierJob: pendingSupplierJobByIdSelector(state, jobId),
    categories: supplierCategoriesListSelector(state),
    suppliersIsLoading: suppliersIsLoadingSelector(state),
    categoriesIsLoading: supplierCategoriesIsLoadingSelector(state)
  };
};
export default connect(mapStateToProps, {
  getSupplierJob: getSinglePendingSupplierJobAction,
  moderateSupplierJob: moderateCreateSinglePendingSupplierJobAction,
  deleteSupplierJob: deleteSinglePendingSupplierProdcutAction,
  getJobs: getPendingSupplierJobsAction,
  getCategories: getSupplierCategoriesAction
})(SupplierJobsForm);
